import { Paths } from "@/modules/application/common/enum";
import {
  AccountClosureApplicationPage,
  AccountOpeningApplicationPage,
  ApplicationHistoryPage,
  ApplicationsPage,
  CardServiceInstructionApplicationPage,
  DepositTerminationApplicationPage,
  LoanTrancheDisbursementApplicationPage,
  PayrollCardOpeningApplicationPage,
  PeriodicalPaymentsApplicationPage,
  PhoneBankingApplicationPage,
  UserOpeningApplicationPage,
} from "@/modules/application/pages";
import { FeatureToggle } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const applicationRoutes: RouteObject[] = [
  {
    path: Paths.Applications,
    element: <Layout/>,
    handle: {
      breadcrumb: () => ({ key: "breadcrumb.applications" }),
    },
    children: [
      {
        path: "",
        element: <ApplicationsPage/>,
      },
      {
        path: Paths.AccountOpeningApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountOpeningApplicationAvailable}
            element={<AccountOpeningApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountOpeningApplication" })
        }
      },
      {
        path: Paths.AccountOpeningApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountOpeningApplicationAvailable}
            element={<AccountOpeningApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountOpeningApplicationUpdate" })
        }
      },
      {
        path: Paths.AccountOpeningApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountOpeningApplicationAvailable}
            element={<AccountOpeningApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountOpeningApplicationCopy" })
        }
      },
      {
        path: Paths.AccountClosureApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountClosureApplicationAvailable}
            element={<AccountClosureApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountClosureApplication" })
        }
      },
      {
        path: Paths.AccountClosureApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountClosureApplicationAvailable}
            element={<AccountClosureApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountClosureApplicationUpdate" })
        }
      },
      {
        path: Paths.AccountClosureApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isAccountClosureApplicationAvailable}
            element={<AccountClosureApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.accountClosureApplicationCopy" })
        }
      },
      {
        path: Paths.PhoneBankingApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPhoneBankingApplicationAvailable}
            element={<PhoneBankingApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.phoneBankingApplication" })
        }
      },
      {
        path: Paths.PhoneBankingApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPhoneBankingApplicationAvailable}
            element={<PhoneBankingApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.phoneBankingApplicationUpdate" })
        }
      },
      {
        path: Paths.PhoneBankingApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPhoneBankingApplicationAvailable}
            element={<PhoneBankingApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.phoneBankingApplicationCopy" })
        }
      },
      {
        path: Paths.PayrollCardOpeningApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPayrollCardOpeningApplicationAvailable}
            element={<PayrollCardOpeningApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.payrollCardOpeningApplication" })
        }
      },
      {
        path: Paths.PayrollCardOpeningApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPayrollCardOpeningApplicationAvailable}
            element={<PayrollCardOpeningApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.payrollCardOpeningApplicationUpdate" })
        }
      },
      {
        path: Paths.PayrollCardOpeningApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPayrollCardOpeningApplicationAvailable}
            element={<PayrollCardOpeningApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.payrollCardOpeningApplicationCopy" })
        }
      },
      {
        path: Paths.LoanTrancheDisbursementApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanTrancheDisbursementApplicationAvailable}
            element={<LoanTrancheDisbursementApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanTrancheDisbursementApplication" })
        }
      },
      {
        path: Paths.LoanTrancheDisbursementApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanTrancheDisbursementApplicationAvailable}
            element={<LoanTrancheDisbursementApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanTrancheDisbursementApplicationUpdate" })
        }
      },
      {
        path: Paths.LoanTrancheDisbursementApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isLoanTrancheDisbursementApplicationAvailable}
            element={<LoanTrancheDisbursementApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.loanTrancheDisbursementApplicationCopy" })
        }
      },
      {
        path: Paths.CardServiceInstructionApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPaymentCardServiceInstructionApplicationAvailable}
            element={<CardServiceInstructionApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.paymentCardServiceInstructionApplication" })
        }
      },
      {
        path: Paths.CardServiceInstructionApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPaymentCardServiceInstructionApplicationAvailable}
            element={<CardServiceInstructionApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.paymentCardServiceInstructionApplicationUpdate" })
        }
      },
      {
        path: Paths.CardServiceInstructionApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPaymentCardServiceInstructionApplicationAvailable}
            element={<CardServiceInstructionApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.paymentCardServiceInstructionApplicationCopy" })
        }
      },
      {
        path: Paths.PeriodicalPaymentsApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPeriodicalPaymentsApplicationAvailable}
            element={<PeriodicalPaymentsApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.periodicalPaymentsApplication" })
        }
      },
      {
        path: Paths.PeriodicalPaymentsApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPeriodicalPaymentsApplicationAvailable}
            element={<PeriodicalPaymentsApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.periodicalPaymentsApplicationUpdate" })
        }
      },
      {
        path: Paths.PeriodicalPaymentsApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isPeriodicalPaymentsApplicationAvailable}
            element={<PeriodicalPaymentsApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.periodicalPaymentsApplicationCopy" })
        }
      },
      {
        path: Paths.UserOpeningApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isUserOpeningApplicationAvailable}
            element={<UserOpeningApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.userOpeningApplication" })
        }
      },
      {
        path: Paths.UserOpeningApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isUserOpeningApplicationAvailable}
            element={<UserOpeningApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.userOpeningApplicationUpdate" })
        }
      },
      {
        path: Paths.UserOpeningApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isUserOpeningApplicationAvailable}
            element={<UserOpeningApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.userOpeningApplicationCopy" })
        }
      },
      {
        path: Paths.DepositTerminationApplication,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isDepositTerminationApplicationAvailable}
            element={<DepositTerminationApplicationPage/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.depositTerminationApplication" })
        }
      },
      {
        path: Paths.DepositTerminationApplicationUpdate,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isDepositTerminationApplicationAvailable}
            element={<DepositTerminationApplicationPage isEdit/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.depositTerminationApplicationUpdate" })
        }
      },
      {
        path: Paths.DepositTerminationApplicationCopy,
        element: (
          <FeatureToggleRoute
            featureFlag={FeatureToggle.isDepositTerminationApplicationAvailable}
            element={<DepositTerminationApplicationPage isCopy/>}
          />
        ),
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.depositTerminationApplicationCopy" })
        }
      },
    ],
  },
  {
    path: Paths.ApplicationHistory,
    element: <Layout/>,
    children: [
      {
        path: "",
        element: <ApplicationHistoryPage/>,
        handle: {
          breadcrumb: () => ({ key: "breadcrumb.applicationHistory" })
        }
      },
    ],
  },
];
